/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['admin'],
  staff: ['admin', 'staff','ReStock Team'],
  user: ['admin', 'staff', 'user','ReStock Team'],
  onlyGuest: [],
};

export default authRoles;
